import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Services } from "../../api/Services";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import ModalViewAttachmets from "../Attachments/ModalViewAttachmets";
import CalenderDay from "./CalenderDay";
import ErrorModal from "../common/ErrorModal/ErrorModal";

const CalenderView = ({ id, detailId, currentDay }) => {
  const storedDate = localStorage.getItem("calenderViewDate");
  const [selectedDate, setSelectedDate] = useState(() => {
    return storedDate ? new Date(storedDate) : new Date();
  });
  const [isLoading, setIsLoading] = useState(false);
  const [workouts, setWorkouts] = useState([]);
  const [workoutName, setWorkoutName] = useState("");
  const navigate = useNavigate();

  const [isCopied, setIsCopied] = useState(false);
  const [workoutid, setWorkoutid] = useState("");
  const setWorkoutIdFunction = (workidd, name) => {
    setWorkoutid(workidd);
    setWorkoutName(name);
    setIsCopied(true);
  };
  const [showModal, setShowModal] = useState(false);
  const [selectedWokrout, setSelectedWorkout] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmActionType, setConfirmActionType] = useState("");
  const [confirmActionData, setConfirmActionData] = useState({});
  const [confirmActionMessage, setConfirmActionMessage] = useState("");
  const [confirmActionButton, setConfirmActionButton] = useState("");

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getWeeksOfMonth = (month, year) => {
    const weeks = [];
    const firstDayOfMonth = new Date(year, month, 1);
    const lastDayOfMonth = new Date(year, month + 1, 0);

    let currentWeek = [];
    let currentDate = new Date(firstDayOfMonth);

    while (currentDate <= lastDayOfMonth) {
      currentWeek.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);

      if (currentWeek.length === 7 || currentDate > lastDayOfMonth) {
        weeks.push([...currentWeek]);
        currentWeek = [];
      }
    }

    return weeks;
  };

  const weeks = getWeeksOfMonth(
    selectedDate?.getMonth(),
    selectedDate?.getFullYear()
  );

  const fetchProgramDetails = async (programId, date) => {
    setIsLoading(true);
    try {
      const result = await Services.getProgrammDetailByDate(programId, date);
      if (result.status === 200) {
        setWorkouts(result?.data?.data?.workouts || []);
        // toast.success("Workouts loaded successfully!", {
        //   autoClose: 2000,
        //   pauseOnHover: true,
        //   draggable: true,
        //   position: toast.POSITION.TOP_CENTER,
        // });
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("Failed to load workouts.", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getWorkoutsForDate = (date) => {
    const formattedDate = formatDate(date);
    return workouts?.filter((workout) =>
      workout.calendar_dates.includes(formattedDate)
    );
  };

  // Function to calculate the index of the default day
  const getDefaultDayIndex = (selectedMonth, selectedYear) => {
    const today = new Date();
    const isSameMonth =
      today.getMonth() === selectedMonth &&
      today.getFullYear() === selectedYear;

    if (isSameMonth) {
      const weeks = getWeeksOfMonth(selectedMonth, selectedYear);
      const flatDays = weeks.flat();
      return flatDays.findIndex(
        (date) => formatDate(date) === formatDate(today)
      );
    } else {
      const weeks = getWeeksOfMonth(selectedMonth, selectedYear);
      const flatDays = weeks.flat();
      return flatDays.findIndex((date) => date.getDate() === 1);
    }
  };

  useEffect(() => {
    const defaultDayIndex = getDefaultDayIndex(
      selectedDate.getMonth(),
      selectedDate.getFullYear()
    );
    setSelectedIndex(defaultDayIndex);
  }, [selectedDate]);

  useEffect(() => {
    if (selectedDate instanceof Date && !isNaN(selectedDate)) {
      localStorage.setItem("calenderViewDate", selectedDate.toISOString());
    }
    fetchProgramDetails(id, formatDate(selectedDate));
  }, [selectedDate]);

  // delete workout
  const deleteworkoutt = async (workoutId, day) => {
    setConfirmActionType("delete_workout");
    setConfirmActionData({ workoutId, day });
    setConfirmActionMessage("Do you want to delete this workout?");
    setConfirmActionButton("Delete");
    setShowConfirmModal(true);
  };

  // duplicate workout
  const duplicatework = async (pid, wid, wdate) => {
    setConfirmActionType("duplicate_workout");
    setConfirmActionData({ pid, wid, wdate });
    setConfirmActionMessage("Do you want to duplicate this workout?");
    setConfirmActionButton("Duplicate");
    setShowConfirmModal(true);
  };

  // handle confirmation from ErrorModal
  const handleConfirmAction = async () => {
    if (confirmActionType === "delete_workout") {
      const { workoutId, day } = confirmActionData;
      try {
        setIsLoading(true);
        const result = await Services.deleteWorkout(workoutId, day);
        if (result.status === 200) {
          await fetchProgramDetails(id, formatDate(selectedDate));
          toast.success("Workout deleted successfully!", {
            autoClose: 1500,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        } else {
          toast.error(result.data.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    } else if (confirmActionType === "duplicate_workout") {
      const { pid, wid, wdate } = confirmActionData;
      try {
        const result = await Services.duplicateWorkout(pid, wid, wdate);
        if (result.status === 200) {
          toast.success("Workout duplicated successfully!", {
            autoClose: 1500,
            pauseOnHover: true,
            draggable: true,
          });
          setIsCopied(false);
          fetchProgramDetails(id, formatDate(selectedDate));
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
          });
          setIsCopied(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
    setShowConfirmModal(false);
  };

  const formateSetsinputs = (sets) => {
    const uniqueValues = {};

    // Iterate through the main array of objects
    sets.forEach((set) => {
      // Iterate through inputs of each set
      set.inputs.forEach((input) => {
        const fieldName = input.field_name;
        const value = input.value;

        if (!uniqueValues[fieldName]) {
          uniqueValues[fieldName] = new Set();
        }

        uniqueValues[fieldName].add(value);
      });
    });

    // Convert unique values back to arrays
    const formattedValues = {};
    for (const fieldName in uniqueValues) {
      formattedValues[fieldName] = Array.from(uniqueValues[fieldName]);
    }

    return formattedValues;
  };

  const handleAddWorkout = (date) => {
    localStorage.setItem("wStartDate", formatDate(date));
    localStorage.setItem(
      "cday",
      date.toLocaleString("default", {
        weekday: "long",
      })
    );
    navigate(`/create-workout/${id}`);
  };

  const handleViewAttachment = (workout) => {
    setSelectedWorkout(workout);
    setShowModal(true);
  };

  const viewWorkoutAttachment = () => {
    return (
      <ModalViewAttachmets
        wokroutId={selectedWokrout?.id}
        programId={id}
        setShowModal={setShowModal}
      />
    );
  };

  return (
    <div className="calender-view-main">
      {showConfirmModal && (
        <ErrorModal
          handleOK={handleConfirmAction}
          errorMessage={confirmActionMessage}
          setErrorMessage={setConfirmActionMessage}
          setErrorModal={setShowConfirmModal}
          actionButtonTitle={confirmActionButton}
        />
      )}
      {isLoading && (
        <div className="loaderparent">
          <div className="loader"></div>
        </div>
      )}
      {showModal && viewWorkoutAttachment()}
      <ToastContainer />
      {/* Date Picker */}
      <div className="date-picker d-flex flex-row justify-content-between align-items-center">
        <button
          className="date-button"
          onClick={() =>
            setSelectedDate(
              new Date(selectedDate?.setMonth(selectedDate?.getMonth() - 1))
            )
          }
        >
          Previous
        </button>
        <DatePicker
          selected={selectedDate}
          onChange={(date) => setSelectedDate(date)}
          dateFormat="MMMM yyyy"
          showMonthYearPicker
        />
        <button
          className="date-button"
          onClick={() =>
            setSelectedDate(
              new Date(selectedDate?.setMonth(selectedDate?.getMonth() + 1))
            )
          }
        >
          Next
        </button>
      </div>

      {/* Loading Indicator */}

      {/* Display Weeks */}

      <div className="main-custom-container hide-on-mobile">
        {weeks?.map((week, index) => (
          <div key={index} className="custom-container-row">
            {week?.map((date, i) => {
              const dayWorkouts = getWorkoutsForDate(date); // Get workouts for the current day
              return (
                <div
                  className="custom-container-col"
                  key={i}
                  style={{
                    backgroundColor:
                      formatDate(date) === formatDate(new Date())
                        ? "#ddd"
                        : "white",
                  }}
                >
                  <div className="header">
                    <span className="text">
                      {date.toLocaleString("default", { month: "short" })}{" "}
                      {date.getDate()},
                      {date.toLocaleString("default", { weekday: "short" })}
                    </span>
                  </div>
                  <CalenderDay
                    id={id}
                    dayWorkouts={dayWorkouts}
                    duplicatework={duplicatework}
                    deleteworkoutt={deleteworkoutt}
                    isCopied={isCopied}
                    setWorkoutIdFunction={setWorkoutIdFunction}
                    handleAddWorkout={handleAddWorkout}
                    handleViewAttachment={handleViewAttachment}
                    date={date}
                    formatDate={formatDate}
                    workoutid={workoutid}
                    formateSetsinputs={formateSetsinputs}
                  />
                </div>
              );
            })}
          </div>
        ))}
      </div>

      {/* Calendar Weeks */}
      <div className={`main-custom-container show-on-mobile`}>
        <div className="days-list d-flex flex-row justify-content-start align-items-center">
          {weeks.flat().map((date, index) => {
            const isActive = index === parseInt(selectedIndex);
            const dayWorkouts = getWorkoutsForDate(date);
            const dotsCount = dayWorkouts.length;

            return (
              <div key={index} className={`day-box d-flex flex-column`}>
                <span className="day">
                  {date.toLocaleDateString("default", { weekday: "short" })}
                </span>

                <span
                  className={`date ${isActive ? "active" : ""}`}
                  onClick={() => setSelectedIndex(`${index}`)}
                >
                  {date.getDate()}
                </span>

                <div className="dots-container">
                  {Array.from({ length: Math.ceil(dotsCount / 8) }).map(
                    (_, rowIndex) => (
                      <div
                        key={rowIndex}
                        className="dots-row d-flex flex-row justify-content-center aling-items-center"
                      >
                        {Array.from({ length: 8 }).map((_, dotIndex) => {
                          const dotPosition = rowIndex * 8 + dotIndex;
                          if (dotPosition >= dotsCount) return null;
                          return (
                            <span key={dotPosition} className="dot"></span>
                          );
                        })}
                      </div>
                    )
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <div className="custom-container-row">
          {selectedIndex !== null && (
            <div
              className="custom-container-col hide-on-mobile"
              style={{
                backgroundColor:
                  formatDate(weeks.flat()[selectedIndex]) ===
                  formatDate(new Date())
                    ? "#ddd"
                    : "white",
              }}
            >
              <CalenderDay
                id={id}
                dayWorkouts={getWorkoutsForDate(weeks.flat()[selectedIndex])}
                duplicatework={duplicatework}
                deleteworkoutt={deleteworkoutt}
                isCopied={isCopied}
                setWorkoutIdFunction={setWorkoutIdFunction}
                handleAddWorkout={handleAddWorkout}
                handleViewAttachment={handleViewAttachment}
                date={weeks.flat()[selectedIndex]}
                formatDate={formatDate}
                workoutid={workoutid}
                formateSetsinputs={formateSetsinputs}
              />
            </div>
          )}
        </div>
      </div>

      {isCopied && (
        <div className="floating-toast">
          <div
            className="icon"
            onClick={() => {
              setIsCopied(false);
              setWorkoutName("");
            }}
          >
            <i className="fa fa-times"></i>
          </div>
          {workoutName} workout is copied,click paste icon to duplicate
        </div>
      )}
    </div>
  );
};

export default CalenderView;
